





import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ErrorHeaderSection',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
